import React, { useContext, useEffect, useState } from 'react'
import { AppState } from '../App'
import Header from './Header';
import Register from './Register';
import UserInfo from './UserInfo';
import Socials from './Socials';
import Navigation from './Navigation';
import CopyToClipboard from 'react-copy-to-clipboard';
import { message } from 'antd';
import { TailSpin } from 'react-loader-spinner';
import { CopyFilled, LikeFilled } from '@ant-design/icons';
import { ethers } from 'ethers';
import { useTimer } from 'react-timer-hook';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Claim from './Claim';
import Requests from './Requests';

function MyTimer({ expiryTimestamp }) {
  const {
    seconds,
    minutes,
    hours,
    days
  } = useTimer({ expiryTimestamp});

  return <p><span>{days > 0 ? `${days.toString()} Days -` : null} {hours.toString().padStart(2, '0')}H </span>:<span>{minutes.toString().padStart(2, '0')}M </span>:<span>{seconds.toString().padStart(2, '0')}S </span></p>
}

const Rewards = () => {
  const useAppState = useContext(AppState);
  const [lvl, setLvl] = useState(0);
  const [showRoyalty, setShowRoyalty] = useState(false);
  const [roayltyTime, setRoyaltyTime] = useState(0);
  const [lifestyleTime, setLifestyleTime] = useState(0);
  const [royalty, setRoyalty] = useState([0,0, 0, 0, 0, 0]);
  const [lifestyle, setLifestyle] = useState([0, 0, 0, 0, 0])
  const [royaltyPrev, setRoyaltyPrev] = useState([0,0,0,0,0,0]);
  const [totalRoyaltyUsers, setTotalRoyaltyUsers] = useState([0, 0, 0, 0, 0, 0]);
  const [lifestyleTaken, setLifestyleTaken] = useState([0,0,0,0,0]);
  const [lifestylePrev, setLifestylePrev] = useState([0,0,0,0,0]);
  const [totalLifestyleUsers, setTotalLifestyleUsers] = useState([0, 0, 0, 0, 0, 0]);

  useEffect(() => {
    async function getData() {
      let _user = await useAppState.staticContract.userInfo(useAppState.id);
      setLvl(Number(_user.level))

      setRoyaltyTime(Number(await useAppState.staticContract.getRoyaltyTime()));
      setLifestyleTime(Number(await useAppState.staticContract.getLifestyleTime()));
      setShowRoyalty(true);

      let curRoyaltyDay = await useAppState.staticContract.getCurRoyaltyDay();
      let _royalty = await useAppState.staticContract.royalty(curRoyaltyDay,0);
      let _royalty1 = await useAppState.staticContract.royalty(curRoyaltyDay,1);
      let _royalty2 = await useAppState.staticContract.royalty(curRoyaltyDay,2);
      let _royalty3 = await useAppState.staticContract.royalty(curRoyaltyDay,3);
      let _royalty4 = await useAppState.staticContract.royalty(curRoyaltyDay,4);
      let _royalty5 = await useAppState.staticContract.royalty(curRoyaltyDay,5);
      setRoyalty([useAppState.convert(_royalty), useAppState.convert(_royalty1), useAppState.convert(_royalty2), useAppState.convert(_royalty3), useAppState.convert(_royalty4), useAppState.convert(_royalty5)]);

      if(Number(curRoyaltyDay > 0)) {
        let _royalty = await useAppState.staticContract.royalty(Number(curRoyaltyDay) - 1,0);
        let _royalty1 = await useAppState.staticContract.royalty(Number(curRoyaltyDay) - 1,1);
        let _royalty2 = await useAppState.staticContract.royalty(Number(curRoyaltyDay) - 1,2);
        let _royalty3 = await useAppState.staticContract.royalty(Number(curRoyaltyDay) - 1,3);
        let _royalty4 = await useAppState.staticContract.royalty(Number(curRoyaltyDay) - 1,4);
        let _royalty5 = await useAppState.staticContract.royalty(Number(curRoyaltyDay) - 1,5);
        setRoyaltyPrev([useAppState.convert(_royalty), useAppState.convert(_royalty1), useAppState.convert(_royalty2), useAppState.convert(_royalty3), useAppState.convert(_royalty4), useAppState.convert(_royalty5)]);
      }

  
      let _lifestyleTaken = await useAppState.staticContract.getLifestyleTaken(useAppState.id);    
      setLifestyleTaken([useAppState.convert(_lifestyleTaken[0]), useAppState.convert(_lifestyleTaken[1]), useAppState.convert(_lifestyleTaken[2]), useAppState.convert(_lifestyleTaken[3]), useAppState.convert(_lifestyleTaken[4])]);

      let _rUsers = [];
      for(let i=0; i<6; i++) {
        _rUsers.push(Number(await useAppState.staticContract.royaltyUsers(i)));
      }

      setTotalRoyaltyUsers(_rUsers)

      let curLifestyleDay = await useAppState.staticContract.getCurLifestyleDay();
      let _lifestyle = await useAppState.staticContract.getLifestyleInfo(curLifestyleDay);
      setLifestyle([useAppState.convert(_lifestyle[0][0]), useAppState.convert(_lifestyle[0][1]), useAppState.convert(_lifestyle[0][2]), useAppState.convert(_lifestyle[0][3]), useAppState.convert(_lifestyle[0][4])]);

      if(Number(curLifestyleDay > 0)) {
        let _lifestyle = await useAppState.staticContract.getLifestyleInfo(Number(curLifestyleDay) - 1);
        setLifestylePrev([useAppState.convert(_lifestyle[0][0]), useAppState.convert(_lifestyle[0][1]), useAppState.convert(_lifestyle[0][2]), useAppState.convert(_lifestyle[0][3]), useAppState.convert(_lifestyle[0][4])]);
      }

      let _lUsers = [];
      for(let i=0; i<5; i++) {
        _lUsers.push(Number(_lifestyle[1][i]));
      }

      setTotalLifestyleUsers(_lUsers)
    }
    getData();
  },[useAppState.walletAddress, useAppState.change, useAppState.id])

  const [loading4, setLoading4] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [isRoyaltyAvl, setIsRoyaltyAvl] = useState(false);
  const [royaltyIndex, setRoyaltyIndex] = useState(0);
  const [isLifestyleAvl, setIsLifestyleAvl] = useState([false, false, false, false, false]);
  const [isLifestyleUpdateAvl, setIsLifestyleUpdateAvl] = useState(false);
  const [clubs, setClubs] = useState(["Prime Club", "Elite Club", "Royal Club", "Crown Club", "Supereme Club"]);
  const [userLifestyleLvl, setUserLifestyleLvl] = useState(0);

  useEffect(() => {
        async function getData() {
          setIsRoyaltyAvl(false);
          for(let i=0; i<6; i++) {
            let isAvl = await useAppState.staticContract.isRoyaltyAvl(useAppState.id, i);
            if(isAvl) {
              setIsRoyaltyAvl(true);
              setRoyaltyIndex(i);
            }
          }

          setUserLifestyleLvl(Number(await useAppState.staticContract.lifestyleLevel(useAppState.id)));
          
          let _isAvl = [false, false, false, false, false];
          for(let i=0; i<5; i++) {
            let isAvl = await useAppState.staticContract.isLifestyleAvl(useAppState.id, i);
            _isAvl[i] = isAvl;
          }
          setIsLifestyleAvl(_isAvl);
  
          let isUpdateAvl = await useAppState.staticContract.isLifestyleUpdateAvl(useAppState.id);
          setIsLifestyleUpdateAvl(isUpdateAvl);
        }
        getData();
      },[useAppState.change, useAppState.walletAddress, useAppState.id])
  
      const claimRoyalty = async () => {
        setLoading4(true);
        try {
          const contract = await useAppState.getContract();
          let tx = await contract.claimRoyalty(lvl - 10);
          await tx.wait();
          useAppState.setChange(useAppState.change + 1);
          message.success("Sucessfully Claimed");
        } catch (error) {
          message.error(error.reason)
        }
        setLoading4(false);
      }
  
      const claimLifestyle = async (i) => {
        setLoading2(true);
        try {
          const contract = await useAppState.getContract();
          let tx = await contract.claimLifestyle(i);
          await tx.wait();
          useAppState.setChange(useAppState.change + 1);
          message.success("Sucessfully Claimed");
        } catch (error) {
          message.error(error.reason)
          console.log(error)
        }
        setLoading2(false);
      }
  
      const updateLifestyle = async () => {
        setLoading3(true);
        try {
          const contract = await useAppState.getContract();
          let tx = await contract.updateLifestyleLevel(useAppState.id);
          await tx.wait();
          useAppState.setChange(useAppState.change + 1);
          message.success("Sucessfully Updated");
        } catch (error) {
          message.error(error.reason)
          console.log(error);
        }
        setLoading3(false);
      }

  return (
    <>
      <img
        src="bgimg.png"
        className="fixed hidden md:block right-0 top-0 z-0 opacity-100 w-full h-full"
      />
      <img
        src="bgmobimg.png"
        className="fixed w-full left-0 md:top-0 block md:hidden top-0 z-0 opacity-100"
      />

      <div className="pb-4 text-black dark:text-white transition-colors duration-1000 min-h-screen relative">
        <Header />

        <div className="flex justify-center w-full px-4 mt-6">
          <div className="w-full md:w-3/4">
            <Navigation />
          </div>
        </div>

        <div className="flex justify-center px-4 md:px-0 mt-6">
  <div className="md:w-3/4 w-full">
    {showRoyalty && (
      <div className="bg-gradient-to-r from-yellow-500 via-green-500 to-blue-500 rounded-lg p-6 shadow-lg mb-8">
        <h3 className="text-2xl font-bold text-white mb-4 text-center">
          Royalty Countdown
        </h3>
        <div className="flex justify-center">
          <p className="text-xl font-mono font-bold text-white">
            <MyTimer expiryTimestamp={roayltyTime * 1000} />
          </p>
        </div>
      </div>
    )}

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {['Icon', 'Legend', 'Emperor', 'Conqueror', 'Chancellor', 'Creator'].map(
        (e, i) => (
          <div
            key={i}
            className="bg-gray-800 bg-opacity-50 p-6 rounded-lg shadow-lg flex flex-col justify-between"
          >
            <h4 className="text-lg font-bold text-yellow-400 mb-2 text-center">
              {e}
            </h4>
            <div className="bg-gray-700 bg-opacity-60 p-2 rounded-md text-center">
              <p className="text-white text-sm font-semibold">Total Users</p>
              <span className="text-xl font-bold text-white">
                {totalRoyaltyUsers[i]}
              </span>
            </div>
            <div className="mt-4">
              <p className="text-sm text-gray-300 text-center">Today</p>
              <p className="text-lg font-bold text-center text-yellow-400">
                {royalty[i]} BNB
              </p>
              <p className="text-sm text-gray-300 mt-2 text-center">
                Previous Day
              </p>
              <p className="text-lg font-bold text-center text-yellow-400">
                {royaltyPrev[i]} BNB
              </p>
            </div>
            {isRoyaltyAvl && i === lvl - 10 && royaltyPrev[lvl - 10] > 0 && (
              <button
                onClick={claimRoyalty}
                className="flex justify-center items-center mt-4 bg-lime-500 text-white text-sm px-4 py-2 rounded-md hover:bg-lime-600 transition-all"
              >
                {loading4 ? <TailSpin color="white" height={14} /> : 'Claim'}
              </button>
            )}
          </div>
        )
      )}
    </div>
  </div>
</div>


<div className="flex justify-center px-4 md:px-0 mt-6">
  <div className="md:w-3/4 w-full">
    {showRoyalty && (
      <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 rounded-lg p-6 shadow-lg mb-8 text-white">
        <h3 className="text-2xl font-bold mb-4 text-center">Rewards Countdown</h3>
        <div className="flex justify-center">
          <p className="text-xl font-bold font-mono">
            <MyTimer expiryTimestamp={lifestyleTime * 1000} />
          </p>
        </div>
      </div>
    )}

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[
        'Prime Club',
        'Elite Club',
        'Royal Club',
        'Crown Club',
        'Supreme Club',
      ].map((e, i) => (
        <div
          key={i}
          className="bg-gray-800 bg-opacity-50 p-6 rounded-lg shadow-lg flex flex-col justify-between"
        >
          <h4 className="text-xl font-bold text-pink-400 mb-4 text-center">{e}</h4>
          <div className="bg-gray-700 bg-opacity-60 p-4 rounded-md text-center mb-4">
            <p className="text-sm text-gray-300">Total Users</p>
            <span className="text-2xl font-bold text-white">
              {totalLifestyleUsers[i]}
            </span>
          </div>
          <div className="text-center">
            <p className="text-sm text-gray-300">This Week</p>
            <p className="text-lg font-bold text-yellow-400">{lifestyle[i]} BNB</p>
            <p className="text-sm text-gray-300 mt-4">Previous Week</p>
            <p className="text-lg font-bold text-yellow-400">
              {lifestylePrev[i]} BNB
            </p>
            <p className="text-sm text-gray-300 mt-4">Income Generated</p>
            <p className="text-lg font-bold text-green-400">${lifestyleTaken[i]}</p>
          </div>
          <div className="mt-4">
            {isLifestyleUpdateAvl && i === userLifestyleLvl && (
              <button
                onClick={updateLifestyle}
                className="w-full bg-blue-500 text-white text-sm px-4 py-2 rounded-md hover:bg-blue-600 transition-all"
              >
                {loading3 ? <TailSpin color="white" height={14} /> : 'Update'}
              </button>
            )}
            {isLifestyleAvl[i] && lifestylePrev[i] > 0 && (
              <button
                onClick={() => claimLifestyle(i)}
                className="w-full bg-green-500 text-white text-sm px-4 py-2 rounded-md hover:bg-green-600 transition-all mt-3"
              >
                {loading2 ? <TailSpin color="white" height={14} /> : 'Claim'}
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


      </div>
    </>
  );
}

export default Rewards